import { Box, Typography } from '@mui/material';

const PHOTOS = [
  { src: '/photos/image02.jpeg', alt: 'Quilles de huit devant le château de Séverac' },
  { src: '/photos/image06.jpeg', alt: 'Soirée au club — convives à table dans la salle' },
  { src: '/photos/image01.jpeg', alt: 'Boule et maillet, maillot Séverac d’Aveyron' },
];

export default function HeroBanner({ title, subtitle, overline }) {
  return (
    <Box
      sx={{
        position: 'relative',
        height: { xs: 220, sm: 280, md: 340 },
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: '0 18px 40px rgba(15, 35, 75, 0.18)',
      }}
    >
      <Box className="hero-mosaic" sx={{ position: 'absolute', inset: 0 }}>
        {PHOTOS.map((p) => (
          <img key={p.src} src={p.src} alt={p.alt} loading="lazy" />
        ))}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(21,101,192,0.25) 0%, rgba(8,18,40,0.55) 60%, rgba(8,18,40,0.78) 100%)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          p: { xs: 2, sm: 3, md: 4 },
          color: '#fff',
        }}
      >
        {overline && (
          <Typography
            variant="overline"
            sx={{ letterSpacing: 2, opacity: 0.9, textShadow: '0 1px 3px rgba(0,0,0,0.6)' }}
          >
            {overline}
          </Typography>
        )}
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            lineHeight: 1.1,
            textShadow: '0 2px 12px rgba(0,0,0,0.55)',
            fontSize: { xs: '1.7rem', sm: '2.2rem', md: '2.7rem' },
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="subtitle1"
            sx={{
              mt: 0.5,
              opacity: 0.95,
              textShadow: '0 1px 6px rgba(0,0,0,0.55)',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
